import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class FollowerService {
  static TIME_FRAMES = ['ALL', 'LAST_MONTH', 'LAST_YEAR']

  constructor() {
    this.endpoints = {
      ...createPrefix('/follower', {
        add: '/add',
        remove: '/remove',
        beneficiaries: '/beneficiary',
        athlete: '/athlete',
        team: '/team',
        tournament: '/tournament',
      }),
    }
  }

  static create() {
    return new FollowerService()
  }

  async addFollowers(params) {
    const servicePath = this.endpoints.add()
    const { data } = await axios.post(servicePath, params)
    return data
  }

  async removeFollowers(params) {
    const servicePath = this.endpoints.remove()
    const { data } = await axios.delete(servicePath, { data: params })
    return data
  }

  async getBeneficiariesFollowers(params) {
    const servicePath = this.endpoints.beneficiaries()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async getAthleteFollowers(params) {
    const servicePath = this.endpoints.athlete()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async getTeamFollowers(params) {
    const servicePath = this.endpoints.team()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async getTournamentFollowers(params) {
    const servicePath = this.endpoints.tournament()
    const { data } = await axios.get(servicePath, { params })
    return data
  }
}
